import pluralize from "pluralize";
import React, { Fragment } from "react";

const cheapestPrice = results => Math.min.apply(null, results.map(result => result.package.price));

const loading = () => (
  <Fragment>
    <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
    <strong>
      Looking for offers
    </strong>
  </Fragment>
);

const notFound = () => (
  <Fragment>
    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
    <strong>
      No offers found
    </strong>
  </Fragment>
);

class Notification extends React.Component {
  found(count) {
    const self = this;
    const { results } = self.props;
    const price = cheapestPrice(results);

    return (
      <Fragment>
        <i className="fa fa-tags" aria-hidden="true" suppressHydrationWarning></i>
        <strong>
          {count} {pluralize("Offer", count)} found from £{price}
        </strong>
      </Fragment>
    );
  }

  render() {
    const self = this;
    const { props } = self;

    if (props.searchDataLoading) {
      return loading();
    }

    const { length } = props.results;

    return length ? self.found(length) : notFound();
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./components/search/Notification.jsx